import { cn } from "@/lib/utils"
import { MemberButton, memberButtonVariants } from "../fun-ui/MemberButton"
import { VipLogoLightIcon } from "../fun-ui/icons"
import { usePayment, useUser } from "@/stores/appStore";
import { VariantProps } from "class-variance-authority";
import { useRouter } from "next/navigation";
import { PaymentDialogCallback } from "@/stores/slices/paymentSlice";
import { PaymentType } from "@/stores/slices/commonSlice";


export const useUpgradeVip = () => {
  const {
    openPayment,
  } = usePayment();
  const {
    user,
  } = useUser();
  const router = useRouter();
  return {
    upgradeVip: (params?: {
      activedPrice?: number;
      callback?: PaymentDialogCallback;
      paymentType?: Extract<PaymentType, 'upgrade' | 'upgradePlus3x'>;
    }) => {
      const { activedPrice, callback, paymentType = 'upgrade' } = params || {};
      if (user?.userId) {
        openPayment({
          type: paymentType,
          price: activedPrice,
          open: true,
        }, callback || null);
      } else {
        const href = `${location.origin}${location.pathname}?open=true&type=${paymentType}&price=${activedPrice}`;
        router.push(`/login?callback=${encodeURIComponent(href)}`); // 未登录，重定向到登录页面
      }
    }
  }
}
export interface UpgradeVipButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
  VariantProps<typeof memberButtonVariants> {
  iconOnly?: boolean;
  withoutIcon?: boolean;
  iconSize?: number;
  activedPrice?: number;
  paymentType?: Extract<PaymentType, 'upgrade' | 'upgradePlus3x'>;
}
export const UpgradeVipButton = ({
  className,
  iconOnly = false,
  withoutIcon = false,
  iconSize = 16,
  children = '升级 Plus 会员',
  onClick,
  activedPrice,
  paymentType = 'upgrade',
  ...props
}: UpgradeVipButtonProps) => {
  const { upgradeVip } = useUpgradeVip();
  return (
    <MemberButton
      onClick={(evt) => {
        onClick?.(evt);
        upgradeVip({
          activedPrice,
          paymentType,
        });
      }}
      className={cn(
        "flex items-center gap-2",
        className,
      )}
      {
      ...props
      }
    >
      {
        withoutIcon ? null : (
          <VipLogoLightIcon size={iconSize} />
        )
      }
      {
        iconOnly ? null : <span>{children}</span>
      }
    </MemberButton>
  )
}